import { OidcProvider, OidcSecure, useOidc } from "@axa-fr/react-oidc"
import { BrowserRouter, Route, Routes } from "react-router-dom"
import { configuration } from "./configuration"
import AccountContextProvider from "./context/AccountContext"
import { env } from "./env"
import "./i18n" // Import i18n configuration
import { ReactComponent as Spinner } from "./images/Spinner.svg"
import "./index.css"
import { AccountDetails } from "./pages/AccountDetails"
import ErrorBoundary from "./pages/ErrorBoundary"
import { GenericErrorPage } from "./pages/GenericErrorPage"
import { Layout } from "./pages/Layout"
import { initializeSentry } from "./sentry"

const LoadingScreen = () => {
  return (
    <div className="flex justify-center items-center h-screen">
      <Spinner className="h-20 w-20" />
    </div>
  )
}
initializeSentry()

const AuthenticatedApp = () => {
  const { logout } = useOidc()

  return (
    <AccountContextProvider onSignedOutEverywhere={logout}>
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={<Layout />}
            errorElement={<GenericErrorPage />}
          >
            <Route index element={<AccountDetails />} />
          </Route>
          <Route path="*" element={<GenericErrorPage />} />
        </Routes>
      </BrowserRouter>
    </AccountContextProvider>
  )
}

function App() {
  return (
    <OidcProvider
      configuration={configuration}
      loadingComponent={LoadingScreen}
      authenticatingComponent={LoadingScreen}
      authenticatingErrorComponent={GenericErrorPage}
      callbackSuccessComponent={() => <></>}
      onSessionLost={() =>
        window.location.replace(`${env.REACT_APP_DASHBOARD_BASE_URL}`)
      }
    >
      <OidcSecure>
        <ErrorBoundary fallback={<GenericErrorPage />}>
          <AuthenticatedApp />
        </ErrorBoundary>
      </OidcSecure>
    </OidcProvider>
  )
}

export default App
